const UPDATE_SAVE_STATUS = 'scratch-gui/project-save/UPDATE_SAVE_STATUS';

const initialState = {
    canSave:true,
    canCreateCopy:true,
    canRemix:true,
    canShare:true
}

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case UPDATE_SAVE_STATUS:
        return Object.assign({}, state, action.session);
    default:
        return state;
    }
};

const updateSaveStatus = status => ({
    type: UPDATE_SAVE_STATUS,
    session: status
});

export {
    reducer as default,
    initialState as projectSaveInitialState,
    updateSaveStatus
};
